export default ({ authGuard, guestGuard }) => [
  { path: '/', name: 'welcome', component: require('~/pages/auth/login.vue') },

  // Authenticated routes.
  ...authGuard([
    { path: '/actors/import', name: 'actors.import', component: require('~/pages/actors/import.vue') },
    { path: '/actors/:actorId/show', name: 'actors.show', component: require('~/pages/actors/show.vue') },
    { path: '/actors/cards', name: 'actors.cards', component: require('~/pages/actors/card.vue') },
    {
      path: '/actors/:actorId/:eventId',
      name: 'actors.new',
      component: require('~/pages/actors/create.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Acteurs',
            disabled: false,
            href: 'actors'
          },
          {
            text: 'Créer un nouvel acteur',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/actors/:actorId/edit',
      name: 'actors.edit',
      component: require('~/pages/actors/edit.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Acteurs',
            disabled: false,
            href: 'actors'
          },
          {
            text: 'Modifier un acteur',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/actors',
      name: 'actors.list',
      component: require('~/pages/actors/index.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Acteurs',
            disabled: false,
            href: 'actors'
          },
          {
            text: 'Liste des acteurs',
            disabled: true
          }
        ],
        permission: 'access actors'
      }
    },
    {
      path: '/actor/validate',
      name: 'actors.list_validate',
      component: require('~/pages/actors/index-validate.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Acteurs',
            disabled: false,
            href: 'actors'
          },
          {
            text: 'Liste des acteurs non validés',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/actor/consent',
      name: 'actors.consent',
      component: require('~/pages/actors/create-consent.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Acteurs',
            disabled: false,
            href: 'actors'
          },
          {
            text: 'Récépissé de consentement',
            disabled: true
          }
        ]
      }
    },
    { path: '/home', name: 'overview', component: require('~/pages/overview/statistic.vue') },
    { path: '/users', name: 'users.list', component: require('~/pages/users/index.vue') },
    { path: '/invitations', name: 'invitations.list', component: require('~/pages/users/invitation-list.vue') },
    { path: '/keys', name: 'keys.list', component: require('~/pages/api/index.vue') },
    {
      path: '/logs',
      name: 'logs.list',
      component: require('~/pages/logs/index.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Logs',
            disabled: false,
            href: '/logs'
          },
          {
            text: 'Liste des logs',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/sessions',
      name: 'sessions.list',
      component: require('~/pages/sessions/index.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Security history',
            disabled: false,
            href: '/sessions'
          },
          {
            text: 'Liste des sessions',
            disabled: true
          }
        ]
      }
    },
    { path: '/settings',
      component: require('~/pages/settings/index.vue'),
      children: [
        { path: '', redirect: { name: 'settings.password' }},
        { path: 'password', name: 'settings.password', component: require('~/pages/settings/password.vue') }
      ]
    },

    { path: '/about', name: 'about',
      component: require('~/pages/overview/about.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'A propos',
            disabled: true,
            href: '/about'
          }
        ]
      }
    },
    { path: '/help', name: 'help',
      component: require('~/pages/overview/help.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Aide',
            disabled: true,
            href: '/help'
          }
        ]
      }
    },
    { path: '/settings/profile', name: 'settings.profile',
      component: require('~/pages/settings/profile.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'general'
          },
          {
            text: 'Profile',
            disabled: true
          }
        ]
      }
    },
    { path: '/settings/countries', name: 'settings.countries', component: require('~/pages/settings/country.vue') },
    { path: '/settings/departments', name: 'settings.departments', component: require('~/pages/settings/department.vue') },
    { path: '/settings/municipalities', name: 'settings.municipalities', component: require('~/pages/settings/municipality.vue') },
    { path: '/settings/districts', name: 'settings.districts', component: require('~/pages/settings/district.vue') },
    { path: '/settings/towns', name: 'settings.towns', component: require('~/pages/settings/town.vue') },
    {
      path: '/settings/maillons',
      name: 'settings.maillons',
      component: require('~/pages/settings/maillons/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: 'Maillons',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/services',
      name: 'settings.services',
      component: require('~/pages/settings/services/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: 'Services',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/langues',
      name: 'settings.languages',
      component: require('~/pages/settings/languages/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: 'Langues',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/event_types',
      name: 'settings.event_types',
      component: require('~/pages/settings/event-types/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: "Types d'évènements",
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/actor_types',
      name: 'settings.actor_types',
      component: require('~/pages/settings/actor-types/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: "Types d'acteurs",
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/school_levels',
      name: 'settings.school_levels',
      component: require('~/pages/settings/school-levels/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: "Niveaux d'instruction",
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/domains',
      name: 'settings.domains',
      component: require('~/pages/settings/domains/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: 'Domaines',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/sae-types',
      name: 'settings-type-sae',
      component: require('~/pages/settings/sae-types/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: 'Types SAE',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/organisator-types',
      name: 'settings-organisator-types',
      component: require('~/pages/settings/organisator-types/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: 'Types organisateurs',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/thematic-types',
      name: 'settings-thematic-type',
      component: require('~/pages/settings/thematic-type.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: 'Thématiques',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/chaines',
      name: 'settings.chains',
      component: require('~/pages/settings/chains/list.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'settings'
          },
          {
            text: 'Chaînes de valeur',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/general',
      name: 'settings.general',
      component: require('~/pages/settings/general.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'general'
          },
          {
            text: 'Général',
            disabled: true
          }
        ]
      }
    },
    { path: '/settings/roles',
      name: 'settings.roles',
      component: require('~/pages/settings/roles/index.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'general'
          },
          {
            text: 'Roles et Permissions',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/roles/:roleId',
      name: 'roles.new',
      component: require('~/pages/settings/roles/create.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'general'
          },
          {
            text: 'Ajouter un nouveau role',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/settings/roles/:roleId/edit',
      name: 'roles.edit',
      component: require('~/pages/settings/roles/create.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'general'
          },
          {
            text: 'Modifier le role',
            disabled: true
          }
        ]
      }
    },
    // { path: '/settings/card_designs', name: 'settings.card_designs', component: require('~/pages/settings/card_design.vue') },

    { path: '/organizations/new', name: 'organizations.new',
      component: require('~/pages/organizations/create.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'general'
          },
          {
            text: 'Créer une organisation',
            disabled: true
          }
        ]
      }
    },
    { path: '/organizations/list/:new_org_added?',
      name: 'organizations.list',
      component: require('~/pages/organizations/index.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Paramètres',
            disabled: false,
            href: 'general'
          },
          {
            text: 'Liste des organisations',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/organizations/no-validate',
      name: 'organizations.no_validate',
      component: require('~/pages/organizations/no-validate.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Organisation',
            disabled: false,
            href: '/organizations/no-validate'
          },
          {
            text: 'Organisations non validées',
            disabled: true
          }
        ]
      }
    },
    { path: '/organizations/:Pid', name: 'organizations.show',
      component: require('~/pages/organizations/show.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Organisation',
            disabled: false,
            href: '/organizations/list'
          },
          {
            text: "Détails sur l'organisation",
            disabled: true
          }
        ]
      }
    },
    { path: '/organizations/:Pid/edit', name: 'organizations.edit',
      component: require('~/pages/organizations/edit.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Organisation',
            disabled: false,
            href: '/organizations/list'
          },
          {
            text: 'Editer organisation',
            disabled: true
          }
        ]
      }
    },

    {
      path: '/events/new',
      name: 'events.new',
      component: require('~/pages/events/create-1.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Créer un évènement - étape 1',
            disabled: true
          }
        ]
      }
    },
    { path: '/events/new-2', name: 'events.new-2',
      component: require('~/pages/events/create-2.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Créer un évènement - étape 2',
            disabled: true
          }
        ]
      }
    },
    { path: '/events/new-3', name: 'events.new-3',
      component: require('~/pages/events/create-3.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Créer un évènement - étape 3',
            disabled: true
          }
        ]
      }
    },
    { path: '/events/new-4', name: 'events.new-4',
      component: require('~/pages/events/create-4.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Créer un évènement - étape 4',
            disabled: true
          }
        ]
      }
    },

    { path: '/events', redirect: { name: 'events.coming' }},
    {
      path: '/events/coming/:new_event_added?',
      name: 'events.coming',
      component: require('~/pages/events/index-coming.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Evènements à réaliser',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/events/in-progress',
      name: 'events.in_progress',
      component: require('~/pages/events/index-in-progress.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/in-progress'
          },
          {
            text: 'Evènements en cours',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/events/import',
      name: 'events.import',
      component: require('~/pages/events/import-event.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/import'
          },
          {
            text: 'Importer des évènements',
            disabled: true
          }
        ]
      }
    },
    { path: '/events/past',
      name: 'events.past',
      component: require('~/pages/events/index-past.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/past'
          },
          {
            text: 'Evènements réalisés',
            disabled: true
          }
        ]
      }
    },
    { path: '/events/validate',
      name: 'events.validate',
      component: require('~/pages/events/index-validate.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/validate'
          },
          {
            text: 'Evènements non validés ',
            disabled: true
          }
        ]
      }
    },

    { path: '/events/:Pid', name: 'events.show',
      component: require('~/pages/events/show.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: "Détails de l'évènement",
            disabled: true
          }
        ]
      }
    },
    { path: '/events/:Pid/participant-cards', name: 'events.participant.card',
    component: require('~/pages/events/participant-card.vue'),
    meta: {
      breadcrumbs: [
        {
          text: 'Evènement',
          disabled: false,
          href: '/events/participants/cards'
        },
        {
          text: "Liste des cards des participants d'un évènement",
          disabled: true
        }
      ]
    }
  },
    { path: '/events/:Pid/edit', name: 'events.edit',
      component: require('~/pages/events/edit-1.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Editer un évènement - étape 1',
            disabled: true
          }
        ]
      }
    },
    { path: '/events/:Pid/participant', name: 'events.participant',
      component: require('~/pages/events/import-participant.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Importer des participants',
            disabled: true
          }
        ]
      }
    },
    
    { path: '/events/edit-2', name: 'events.edit-2',
      component: require('~/pages/events/edit-2.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Editer un évènement - étape 2',
            disabled: true
          }
        ]
      }
    },
    { path: '/events/edit-3', name: 'events.edit-3',
      component: require('~/pages/events/edit-3.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Editer un évènement - étape 3',
            disabled: true
          }
        ]
      }
    },
    { path: '/events/edit-4', name: 'events.edit-4',
      component: require('~/pages/events/edit-4.vue'),
      meta: {
        breadcrumbs: [
          {
            text: 'Evènement',
            disabled: false,
            href: '/events/coming'
          },
          {
            text: 'Editer un évènement - étape 4',
            disabled: true
          }
        ]
      }
    }
  ]),

  // Guest routes.
  ...guestGuard([
    { path: '/login', name: 'login', component: require('~/pages/auth/login.vue') },
    { path: '/actors/details/:id', name: 'actors.details', component: require('~/pages/actors/details.vue') },
    { path: '/invitation/join/:token', name: 'invitation.join', component: require('~/pages/auth/join.vue') },
    { path: '/register/:token', name: 'register', component: require('~/pages/auth/register.vue') },
    { path: '/register/dev/:token', name: 'developer', component: require('~/pages/auth/developer.vue') },
    { path: '/password/reset', name: 'password.request', component: require('~/pages/auth/password/email.vue') },
    { path: '/password/reset/:token', name: 'password.reset', component: require('~/pages/auth/password/reset.vue') }
  ]),

  { path: '*', component: require('~/pages/errors/404.vue') }
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js